import { IArgument, isCategorical } from '@tymely/atoms';

export const getArgumentFindFunction =
    (arg: IArgument) =>
    ({ md_id, name }: IArgument) => {
        if (!isCategorical(arg)) {
            return false;
        }
        if ([arg.search_md_id, arg.regulator_md_id].includes(md_id)) {
            return true;
        }
        if (arg.lazy && arg.group_by === name) {
            return true;
        }
        return false;
    };
